<template>
  <div class="c-success-notification">
    <v-snackbar
      v-model="successMsg"
      color="green"
      :timeout="3000"
      @input="checkValue"
    >
      {{ successMsg }}
      <template v-slot:action="{ attrs }">
        <v-btn
          color="white"
          text
          v-bind="attrs"
          @click="removeSuccess"
        >
          Close
        </v-btn>
      </template>
    </v-snackbar>
  </div>
</template>

<script>

export default {
  name: 'SuccessNotification',
  computed: {
    successMsg: {
      get () {
        return this.$store.getters.getSuccess
      },
      set (newVal) {}
    }
  },
  methods: {
    removeSuccess () {
      this.$store.dispatch('setSuccess', { successMsg: '' })
    },
    checkValue (e) {
      if (!e) this.removeSuccess()
    }
  }
}
</script>

<style lang="scss">
  .c-success-notification {
    position: absolute;
    width: 100%;
    bottom: 0;
    left: 0;
    z-index: 9999;
  }
</style>
